module.exports = __webpack_public_path__ + "img/embroideryTime.a7da7e49.svg";